import React from "react";
import "./App.css";
import tableify from "tableify";
import { Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import NIAPage from "./pages/NIAPage";
import KSRTCPage from "./pages/KSRTCPage";
import { readFirstWorksheetAsJson } from "./utils/excelUtil/excelBrowser";

export const BankStatementRemarksColumnName = "Remarks";

export function getDataCopy<T>(data: T[]): T[] {
  return data.map((datum) => {
    return { ...datum };
  });
}

export function getTable(data: any[] = []) {
  if (data.length === 0) {
    return {
      __html: "",
    };
  }
  const tableString = tableify(
    data.map((datum, index) => {
      return {
        "#": index + 1,
        ...datum,
      };
    })
  );
  return {
    __html: tableString,
  };
}

export function addUniqueId<T>(data: T[]): T[] {
  const dataWithUniqueId = data.map((datum, index) => {
    return { ID: 1000 + (index + 1), ...datum };
  });
  return dataWithUniqueId;
}

export async function readExcelFile(
  fileChangeEvent: React.ChangeEvent<HTMLInputElement>
): Promise<unknown[] | undefined> {
  const files = fileChangeEvent.target.files;
  if (files) {
    const file = files[0];
    return readFirstWorksheetAsJson(file);
  }
  Promise.resolve(undefined);
}

function App() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/nia" component={NIAPage} />
      <Route path="/ksrtc" component={KSRTCPage} />
    </Switch>
  );
}

export default App;
